import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { enums } from "../../enums/enums";
import DatosMercancia from "../datosMercancia/datosMercancia";
import DatosCliente from "../datosPersonales/DatosCliente";
import SeccionServicioAdicional from "../servicioAdicional/SeccionServicioAdicional";
import Markup from "../markup/Markup";
import Box from "@material-ui/core/Box";
import RegistroUsuario from "../datosPersonales/RegistroUsuario";
import { ICliente } from "../../entities/catalogos/ICliente";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import Header from '../header/Header';
import ResumenSolicitud from '../resumen/ResumenSolicitud';
import OrigenDestinoSolicitud from '../origenDestino/OrigenDestinoSolicitud';
import TipoEnvioSolicitudLista from '../solicitud/TipoEnvioSolicitudLista';
import Facturador from '../Facturador/Facturador';
import Proyecto from '../Proyecto/Proyecto';
import ResumenConfirmacionSS from '../resumen/ResumenConfirmacionSS';
import ResumenConfirmacion from '../resumen/ResumenConfirmacion';
import { IHelp } from '../help/Help';
import useCommonApi from "../../api/useCommonApi";
import swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import { updateServicios } from "../../redux/actions/servicioAdicionalActions";
import { saveMercanciasDatosComplementarios } from "../../redux/actions/mercanciaDatosComplementariosActions";
import ResumenCotizacionInicio from "../resumen/ResumenCotizacionInicio";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import LoadingDialog from '../controls/LoadingDialog';
interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    cliente: ICliente
    usuario: IUsuario
    cotizacionID: number
    ayuda: IHelp
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    updateServicios: typeof updateServicios
    saveMercanciasDatosComplmentarios: typeof saveMercanciasDatosComplementarios
}

type Props = StateProps & DispatchProps

const BodySolicitud = ({ solicitud, cliente, setSolicitud, updateServicios, saveMercanciasDatosComplmentarios }: Props) => {
    const [cotizacionId, setCotizacionID] = useState(0);
    const [guardandoSS, setGuardandoSS] = useState(false);
    const getCotizacionId = (cotizacionId: number) => {
        if (cotizacionId > 0) {
            setCotizacionID(cotizacionId);
        }
    }
    const apiSource = useCommonApi();
    const [datosRemitente, setdatosRemitente] = useState({ latitude: 0, longitude: 0 });
    const [datosDestinatario, setdatosDestinatario] = useState({ latitude: 0, longitude: 0 });
    const [solicitudDTO, setSolicitudDTO] = useState({  });
    const history = useHistory();

    React.useEffect(() => {
        if (solicitud.tipoDocumento !== 2) {
            const copia = new Solicitud({ ...solicitud });
            copia.tipoDocumento = 2;
            setSolicitud(copia);
        }
    }, []);

    React.useEffect(() => {
        
        if(solicitud.esSolicitarDeNuevo){
            const copiaSolicitud = new Solicitud(solicitud);
            copiaSolicitud.fechaCitaRad = undefined;
            copiaSolicitud.fechaCitaEad = undefined;
            copiaSolicitud.fechaCitaRadCedis = undefined;
            copiaSolicitud.fechaCitaEadCedis = undefined;
            copiaSolicitud.EadCitaHoraDe = undefined;
            copiaSolicitud.EadCitaHoraHasta = undefined;
            copiaSolicitud.RadCitaHoraDe = undefined;
            copiaSolicitud.RadCitaHoraHasta = undefined;
            copiaSolicitud.esSolicitarDeNuevoDestino = true;
            copiaSolicitud.esSolicitarDeNuevoOrigen = true;
            setSolicitudCopia(copiaSolicitud);
            setSolicitud(copiaSolicitud);
        }
        saveMercanciasDatosComplmentarios([]);

        if (cliente.id > 0) {
            if (cliente?.clienteCredito?.esSuspendido === true && cliente?.clienteCredito?.tipoPagoID === enums.tipoPago.credito) {
                swal.fire({
                    titleText: traducirMessage(11), //'¡Aviso!',
                    text: traducirMessage(288), // "EL CLIENTE TIENE SU CRÉDITO SUSPENDIDO, NO ES POSIBLE GENERAR LA SOLICITUD DE SERVICIO.",
                    type: 'warning',
                });
                history.push("/");
                return;
            }

            validaCliente(cliente.id).then(result => {
                if (result === 0) {
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(48), // "EL CLIENTE NO TIENE ACTUALIZADOS SUS DATOS FISCALES PARA LA EMISIÓN DEL CFDI 4.0. FAVOR DE CONTACTAR A SU EJECUTIVO DE CUENTA O AL ÁREA DE SERVICIO AL CLIENTE.",
                        type: 'warning',
                    });
                    history.push("/");
                    return;
                }
            });
        }

    }, [cliente])

    React.useEffect(() => {
        if (!guardandoSS) {
            return;
        }
        const desbloquearHistory = history.block(() => false);
        const prevenirSalida = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", prevenirSalida);
        return () => {
            desbloquearHistory();
            window.removeEventListener("beforeunload", prevenirSalida);
        };
    }, [guardandoSS, history]);

    React.useEffect(() => {
        localStorage.setItem("renderiza", "");
    }, [localStorage.getItem("clienteString")]);

    const validaCliente = async (cliente) => {
        let params = {
            clienteId: cliente.toString(),
            modulo: "SOLICITUD SERVICIO EXTERNO NUEVO",
            evento: "NUEVA SOLICITUD",
            username: localStorage.getItem("usuario_nombre")
        };
        const result = await apiSource.postAsync<number>("solicitud-servicio/valida-cliente-datos-cFDI", params);
        return result;
    }

    const handleSiguienteSeccion = (siguienteSeccionId: number, datosSeccion: any, cotizacion_ID?: number, contacto?: any, datosRemitente?: any, datosDestinatario?: any, proyecto?: any, facturador?: any, observaciones?: string, comercioExterior?: any, cruceFronterizo?: any) => {
        if (siguienteSeccionId === enums.estatusSolicitud.markup && !cliente.habilitarClienteLogistico && !cliente.clienteConfiguracionMarkupDetalle.activo) {
            siguienteSeccionId = enums.estatusSolicitud.datosCliente;
        }
        const estatusId = siguienteSeccionId;
        const copiaSolicitud = new Solicitud(solicitud);
        copiaSolicitud.estatusId = estatusId;
        copiaSolicitud.seccionId = siguienteSeccionId;
        copiaSolicitud.tipoDocumento = 2;

        if (datosSeccion && datosSeccion.id) {
            if (solicitud.id && solicitud.id > 0) {
                datosSeccion.id = solicitud.id;
            }
            copiaSolicitud.id = datosSeccion.id;
            copiaSolicitud.completada = datosSeccion.completada;

        }

        switch (siguienteSeccionId) {
            case enums.estatusSolicitud.inicial:
                copiaSolicitud.cotizacionId = datosSeccion.cotizacionId;
                copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;

                copiaSolicitud.correo = datosSeccion.correo;
                copiaSolicitud.direccionRemitente = datosSeccion.direccionRemitente;
                copiaSolicitud.direccionDestinatario = datosSeccion.direccionDestinatario;
                copiaSolicitud.contactoOrigen = datosSeccion.contactoOrigen;
                copiaSolicitud.contactoDestino = datosSeccion.contactoDestino;
                copiaSolicitud.proyecto = proyecto;
                copiaSolicitud.facturador = {
                    id: cliente?.id,
                    clienteNombre: cliente?.nombre,
                    clienteRFC: cliente?.rfc
                }
                copiaSolicitud.clienteReferencias = datosSeccion.clienteReferencias;
                copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                copiaSolicitud.completadaMarkup = false;
                break;
            case enums.estatusSolicitud.facturador:
                copiaSolicitud.proyecto = proyecto;
                copiaSolicitud.completadaMarkup = false;
                break;
            case enums.estatusSolicitud.origenDestino:
                copiaSolicitud.esSeguroMercancia = false;
                copiaSolicitud.completadaMarkup = false;
                if (cliente.grupoClienteID === 0 && cliente.habilitarClienteLogistico) {
                    copiaSolicitud.facturador = facturador;
                }
                else {
                    copiaSolicitud.proyecto = proyecto;
                }
                break;
            case enums.estatusSolicitud.datosMercancia:
                if(datosSeccion.claseId !== -1){
                    copiaSolicitud.completadaMarkup = false;
                    copiaSolicitud.cotizacionId = cotizacion_ID;
                    copiaSolicitud.observaciones = observaciones;
                    if (solicitud.cotizacionId !== null && solicitud.cotizacionId !== 0 && solicitud.cotizacionId !== undefined) {
                        copiaSolicitud.esSeguroBasico = solicitud.esSeguroBasico;
                        copiaSolicitud.esSeguroMercancia = solicitud.esSeguroMercancia;
                    }
                    else {
                        copiaSolicitud.esSeguroBasico = false;
                        copiaSolicitud.esSeguroMercancia = false;
                    }
                    copiaSolicitud.SetDestino(datosSeccion);
                    if (copiaSolicitud.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.residencial) {
                        copiaSolicitud.esResidencialOrigen = true;
                    }
                    if (copiaSolicitud.tipoRecoleccionIdDestino === enums.tipoRecoleccion.residencial) {
                        copiaSolicitud.esResidencialDestino = true;
                    }
                }
                break;
            case enums.estatusSolicitud.serviciosAdicionales:
                copiaSolicitud.completadaMarkup = false;
                copiaSolicitud.descripcionMercancia = datosSeccion.descripcionMercancia;
                copiaSolicitud.claseId = datosSeccion.claseId;
                copiaSolicitud.clase = datosSeccion.clase;
                copiaSolicitud.clienteReferencias = datosSeccion.clienteReferencias;
                copiaSolicitud.CopiarSeccionMercancia(datosSeccion);

                break;
            case enums.estatusSolicitud.markup:
                //copiaSolicitud.AgruparServicios(datosSeccion);
                if (datosSeccion.completada) {
                    copiaSolicitud.id = datosSeccion.solicitudId;
                    copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                    copiaSolicitud.numGuia = datosSeccion.numGuia;
                    copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                    copiaSolicitud.correo = datosSeccion.correo;
                    copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                    copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                    copiaSolicitud.tipoMarkupId = datosSeccion.tipoMarkupId;
                    copiaSolicitud.costoMarkup = datosSeccion.costoMarkup;
                    copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;
                    copiaSolicitud.descuento = datosSeccion.descuento;
                    copiaSolicitud.subtotal = datosSeccion.subtotal;
                    copiaSolicitud.iva = datosSeccion.iva;
                    copiaSolicitud.retencion = datosSeccion.retencion;
                    copiaSolicitud.total = datosSeccion.total;
                    copiaSolicitud.totalPesoVolumen = datosSeccion.totalPesoVolumen;
                    copiaSolicitud.totalPesoFacturado = datosSeccion.totalPesoFacturado;
                    copiaSolicitud.montoPesoFacturado = datosSeccion.montoPesoFacturado;
                    copiaSolicitud.totalPesoMercancia = datosSeccion.totalPesoMercancia;
                    copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                    copiaSolicitud.areaServicioOrigenId = datosSeccion.areaServicioOrigenId;
                    copiaSolicitud.proyecto = datosSeccion.proyecto;
                    copiaSolicitud.facturador = datosSeccion.facturador;
                    copiaSolicitud.archivosAdjuntos = datosSeccion.archivosAdjuntos.length > 0 ? datosSeccion.archivosAdjuntos : [];
                    copiaSolicitud?.fechaCitaRad?.setMinutes(copiaSolicitud?.fechaCitaRad?.getMinutes() + copiaSolicitud?.fechaCitaRad?.getTimezoneOffset())
                    copiaSolicitud?.fechaCitaEad?.setMinutes(copiaSolicitud?.fechaCitaEad?.getMinutes() + copiaSolicitud?.fechaCitaEad?.getTimezoneOffset())
                    copiaSolicitud.cotizacionId = 0;
                    copiaSolicitud.id = datosSeccion.id;
                    copiaSolicitud.completadaMarkup = true;

                    if (datosRemitente !== undefined) {
                        setdatosRemitente({ latitude: datosRemitente.latitude, longitude: datosRemitente.longitude });
                    }
                    if (datosDestinatario !== undefined) {
                        setdatosDestinatario({ latitude: datosDestinatario.latitude, longitude: datosDestinatario.longitude });
                    }
                    copiaSolicitud.completada = true;
                    copiaSolicitud.modificar = datosSeccion.modificar ? datosSeccion.modificar : false;
                    copiaSolicitud.distribuidorDestinatario = datosSeccion.distribuidorDestinatario;
                    copiaSolicitud.distribuidorRemitente = datosSeccion.distribuidorRemitente;
                    setSolicitudDTO(proyecto);
                    setSolicitud(datosSeccion);
                }
                //setSolicitud(datosSeccion);
                break;
            case enums.estatusSolicitud.datosCliente:
                copiaSolicitud.completadaMarkup = false;
                if (cliente.habilitarClienteLogistico && cliente.clienteConfiguracionMarkupDetalle.activo) {
                    copiaSolicitud.AgruparServicios(datosSeccion);
                    copiaSolicitud.CopiarMarkup(datosSeccion);
                } else {
                    copiaSolicitud.AgruparServicios(datosSeccion);
                }
                break;
            case enums.estatusSolicitud.tipoEnvio:
            case enums.estatusSolicitud.cotizacion:
                copiaSolicitud.correo = datosSeccion.correo;
                copiaSolicitud.empresaTarifaAlmex = datosSeccion.empresa;
                copiaSolicitud.nombreTarifaAlmex = datosSeccion.nombre;
                copiaSolicitud.telefonoTarifaAlmex = datosSeccion.telefono;
                copiaSolicitud.esParticularTarifaAlmex = datosSeccion.tipoPersonaId === 2 ? 0 : 1;

                if (datosSeccion.tipoServicio) {
                    copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                }

                if (datosSeccion.completada) {
                    copiaSolicitud.id = datosSeccion.solicitudId;
                    copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                    copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                    copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                    copiaSolicitud.tipoMarkupId = datosSeccion.tipoMarkupId;
                    copiaSolicitud.costoMarkup = datosSeccion.costoMarkup;
                    copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;
                    copiaSolicitud.descuento = datosSeccion.descuento;
                    copiaSolicitud.subtotal = datosSeccion.subtotal;
                    copiaSolicitud.iva = datosSeccion.iva;
                    copiaSolicitud.retencion = datosSeccion.retencion;
                    copiaSolicitud.total = datosSeccion.total;
                    copiaSolicitud.totalPesoVolumen = datosSeccion.totalPesoVolumen;
                    copiaSolicitud.totalPesoFacturado = datosSeccion.totalPesoFacturado;
                    copiaSolicitud.montoPesoFacturado = datosSeccion.montoPesoFacturado;
                    copiaSolicitud.totalPesoMercancia = datosSeccion.totalPesoMercancia;
                    copiaSolicitud.unidadMedidaLongitudId = datosSeccion.unidadMedidaLongitudId;
                    copiaSolicitud.unidadMedidaPesoId = datosSeccion.unidadMedidaPesoId;
                    copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                    copiaSolicitud.completada = true;
                    copiaSolicitud.proyecto = datosSeccion.proyecto;
                    copiaSolicitud.valorMercancia = datosSeccion.valorMercancia;
                    copiaSolicitud.modificar = datosSeccion.modificar ? datosSeccion.modificar : false;
                    copiaSolicitud.completadaMarkup = false;
                    setSolicitud(datosSeccion);
                }
                break;
            case enums.estatusCotizacion.resumen:
                copiaSolicitud.id = datosSeccion.solicitudId;
                copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                copiaSolicitud.numGuia = datosSeccion.numGuia;
                copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                copiaSolicitud.correo = datosSeccion.correo;
                copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                copiaSolicitud.tipoMarkupId = datosSeccion.tipoMarkupId;
                copiaSolicitud.costoMarkup = datosSeccion.costoMarkup;
                copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;
                copiaSolicitud.descuento = datosSeccion.descuento;
                copiaSolicitud.subtotal = datosSeccion.subtotal;
                copiaSolicitud.iva = datosSeccion.iva;
                copiaSolicitud.retencion = datosSeccion.retencion;
                copiaSolicitud.total = datosSeccion.total;
                copiaSolicitud.totalPesoVolumen = datosSeccion.totalPesoVolumen;
                copiaSolicitud.totalPesoFacturado = datosSeccion.totalPesoFacturado;
                copiaSolicitud.montoPesoFacturado = datosSeccion.montoPesoFacturado;
                copiaSolicitud.totalPesoMercancia = datosSeccion.totalPesoMercancia;
                copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                copiaSolicitud.areaServicioOrigenId = datosSeccion.areaServicioOrigenId;
                copiaSolicitud.proyecto = datosSeccion.proyecto;
                copiaSolicitud.facturador = datosSeccion.facturador;
                copiaSolicitud.archivosAdjuntos = datosSeccion.archivosAdjuntos.length > 0 ? datosSeccion.archivosAdjuntos : [];
                copiaSolicitud.cotizacionId = 0;
                copiaSolicitud.id = datosSeccion.id;

                if (datosRemitente !== undefined) {
                    setdatosRemitente({ latitude: datosRemitente.latitude, longitude: datosRemitente.longitude });
                }
                if (datosDestinatario !== undefined) {
                    setdatosDestinatario({ latitude: datosDestinatario.latitude, longitude: datosDestinatario.longitude });
                }
                copiaSolicitud.completada = true;
                copiaSolicitud.completadaMarkup = false;
                copiaSolicitud.modificar = datosSeccion.modificar ? datosSeccion.modificar : false;
                copiaSolicitud.distribuidorDestinatario = datosSeccion.distribuidorDestinatario;
                copiaSolicitud.distribuidorRemitente = datosSeccion.distribuidorRemitente;
                break;
            default:
                break;
        }

        setSolicitud(copiaSolicitud);
    };

    let bloqueandoSolicitud =
    sessionStorage.getItem("bloqueandoSolicitudServicio") != undefined && sessionStorage.getItem("bloqueandoSolicitudServicio") === "1";
  
    if (solicitud.seccionId === enums.estatusSolicitud.resumen || solicitud.seccionId === enums.estatusCotizacion.proyecto || solicitud.seccionId === enums.estatusSolicitud.inicial || solicitud.seccionId === enums.estatusSolicitud.facturador) {
        bloqueandoSolicitud = false;
        sessionStorage.removeItem("bloqueandoSolicitudServicio");
    }

    let seccion;

    if (bloqueandoSolicitud) {

        seccion = (
            <LoadingDialog
                titulo={traducirLabel(240)}
                abierto={true}
            />
        );

        } else {
            switch (solicitud.seccionId) {
        // switch (2) {
        case enums.estatusSolicitud.inicial:
            // seccion = <ResumenConfirmacion cotizacionId={cotizacionId} />;
            seccion = <ResumenCotizacionInicio siguienteSeccion={handleSiguienteSeccion} cotizacionId={solicitud.cotizacionId} />
            break;
        case enums.estatusSolicitud.facturador:
            seccion = <Facturador cotizacionId={cotizacionId} siguienteSeccion={handleSiguienteSeccion} />;
            break;
        case enums.estatusSolicitud.proyecto:
            if (cliente.grupoClienteID >= 0 && (cliente.clienteCreditoProyecto && cliente.clienteCreditoProyecto?.length >= 2)) {
                seccion = <Proyecto cotizacionId={cotizacionId} siguienteSeccion={handleSiguienteSeccion} />;
            }
            else if (cliente.grupoClienteID === 0 && cliente.habilitarClienteLogistico) {
                seccion = <Facturador cotizacionId={cotizacionId} siguienteSeccion={handleSiguienteSeccion} />;
            }
            else {
                seccion = <OrigenDestinoSolicitud siguienteSeccion={handleSiguienteSeccion} setCotizacionID={getCotizacionId} cotizacionId={cotizacionId} />;
            }

            break;
        case enums.estatusSolicitud.origenDestino:
            seccion = <OrigenDestinoSolicitud siguienteSeccion={handleSiguienteSeccion} setCotizacionID={getCotizacionId} cotizacionId={cotizacionId} />;
            break;
        case enums.estatusSolicitud.datosMercancia:
            seccion = <DatosMercancia siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} />;
            break;
        case enums.estatusSolicitud.serviciosAdicionales:
            seccion = <SeccionServicioAdicional siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} />;
            break;
        case enums.estatusSolicitud.markup:
            //seccion = <Markup siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} datosRemitente={datosRemitente} datosDestinatario={datosDestinatario} solicitudDTO={solicitudDTO} />;
            seccion = <TipoEnvioSolicitudLista siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} solicitudDTO={solicitudDTO} guardandoSS={guardandoSS} setGuardandoSS={setGuardandoSS}/>;
            break;
        case enums.estatusSolicitud.datosCliente:
            seccion = <DatosCliente siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} />;
            break;
        case enums.estatusSolicitud.tipoEnvio:
            seccion = <TipoEnvioSolicitudLista siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} guardandoSS={guardandoSS} setGuardandoSS={setGuardandoSS}/>;
            break;
        case enums.estatusSolicitud.cotizacion:
            seccion = <ResumenSolicitud siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} />
            break;
        case enums.estatusCotizacion.resumen:
            seccion = <ResumenConfirmacionSS siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} datosRemitente={datosRemitente} datosDestinatario={datosDestinatario} />;
            break;
        case enums.estatusSolicitud.registroUsuario:
            seccion = <RegistroUsuario cotizacionId={0} />;
            break;
        default:
            break;

        }
    }

    return (<>
        <Header name="Developer" tipo={'solicitud servicio'} solicitud={solicitud}  guardandoSS={guardandoSS}/>
        <div style={{ width: '90%', margin: 'auto', marginTop: '2em' }}>

            {cliente?.id !== null && !solicitud.completada && solicitud.seccionId !== 0 &&
                <Grid container spacing={4}>
                    <Box clone order={{ xs: 2, md: 1 }}>
                        <Grid item xs={12} md={8}>
                            <Paper elevation={3}>
                                {seccion}
                            </Paper>
                        </Grid>
                    </Box>

                    <Box clone order={{ xs: 1, md: 2 }}>
                        <Grid item xs={12} md={4}>
                            <ResumenSolicitud />
                        </Grid>
                    </Box>

                </Grid>

            }

            {solicitud.completada && solicitud.modificar && solicitud.seccionId !== 8 && solicitud.seccionId !== 9
                && solicitud.seccionId !== 0 &&
                <Grid container spacing={4}>
                    <Box clone order={{ xs: 2, md: 1 }}>
                        <Grid item xs={12} md={8}>
                            <Paper elevation={3}>
                                {seccion}
                            </Paper>
                        </Grid>
                    </Box>

                    <Box clone order={{ xs: 1, md: 2 }}>
                        <Grid item xs={12} md={4}>
                            <ResumenSolicitud />
                        </Grid>
                    </Box>

                </Grid>

            }

            {(solicitud.seccionId === 8 || solicitud.seccionId === 9 || solicitud.seccionId === 0) &&
                <>{seccion}</>
            }
        </div>
    </>)
};

const mapStateToProps = (state: ApplicationState) => (
    {
        solicitud: state.solicitud,
        solicitudCopia: state.solicitudCopia,
        cliente: state.cliente,
        recoleccionOrigen: state.recoleccionDestino,
        recoleccionDestino: state.recoleccionDestino,
        usuario: state.usuario,
        ayuda: state.ayuda
    });

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionOrigen,
    updateServicios: updateServicios,
    saveMercanciasDatosComplmentarios: saveMercanciasDatosComplementarios
};

export default connect(mapStateToProps, mapDispatchToProps)(BodySolicitud);